export const messages = {
  disclaimerCta: {
    defaultMessage: 'View disclaimer details',
    id: 'fa.carousel.disclaimer.cta',
  },
  wltpFallback: {
    defaultMessage: 'WLTP data not available.',
    id: 'fa.carousel.wltp.fallback',
  },
};
